define('views/modules/profile/edit/account-settings-edit-form',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils',
    // src
    'services/user',
    'services/api',
    // services
    'services/i18n',
    'services/events/user-events',
    // views
    'views/parts/form/textbox',
    'views/parts/info-section',
    'views/parts/form/choices',
    'views/parts/form/datepicker',
    'views/parts/tree/tree-view',
    'views/parts/menu/menu-dropdown',
    // templates
    'text!templates/modules/profile/edit/account-settings-edit-form.html',
], function(
    // Libs
    _, Backbone, Mustache, U,
    // src
    User,
    API,
    //services
    i18n,
    UserEvents,
    // views
    VTextBox,
    VInfoSection,
    VChoices,
    VDatePicker,
    VTreeView,
    VMenuDropdown,
    // templates
    TAccountSettingsEditForm
) {

    var VAccountSettingsEditForm = Backbone.View.extend({
        template: TAccountSettingsEditForm,

        regions: {
            form: {
                supervisor: '.supervisor-input',
                expiration: '.expiration-input',
                phone: '.phone-input',
                groups: "#group-menu",
                calorie_goal: '.calorie-goal',
                disable_calorie_goal: '.disable-calorie-goal'
            }
        },

        initialize: function(opt) {
            this.selectedGroup = opt.selectedGroup;

            this.options = opt || {};

            var groupTreeView = new VTreeView({
                label: 'name',
                subgroup: 'subgroups',
                activeAttribute: '_menuActive',
                depth: 5,
                toggleActive: true,
                firstOpen: true,
                collection: this.collection
            });

            this.setDefaultCalorieGoal();

            this.view = {
                info: new VInfoSection({
                    title: "supervisor:member-additionnal-settings",
                    //help: "messages:helpbox-account-settings",
                    content: this.template,
                }),
                form: {
                    groups: new VMenuDropdown({
                        displayManageGroup: User.getMainGroup().isOwner,
                        label: "Group",
                        context: this,
                        showLabel: true,
                        labelposition: "top",
                        callback: this.onDisplayGroupManager,
                        collection: new Backbone.Collection([
                            { tree: true, tree_only: true, view: groupTreeView }
                        ]),
                    }),

                    expiration: new VDatePicker({
                        label: 'Expiration',
                        attribute: '_expire',
                        model: this.model,
                        labelposition: "top",
                        help: 'form-profile-expiration-help',
                        format: API.format.timestamp
                    }),

                    phone: new VTextBox({
                      placeholder: 'form-profile-phone-placeholder',
                      label: 'form-profile-phone',
                      help: 'form-profile-phone-help',
                      attribute: 'phone',
                      labelposition: "top",
                      model: this.model
                    }),

                    calorie_goal: new VTextBox({
                      labelposition: "top",
                      placeholder: "form-profile-calories-placeholder",
                      label: "form-profile-calories",
                      help: "form-profile-calories-help",
                      model: this.model,
                      attribute: "calorie_goal"
                    }),

                    disable_calorie_goal: new VChoices({
                      type: "checkbox",
                      model: this.model,
                      attribute: 'disable_calorie_goal',
                      label: 'form-profile-disable-calorie-goal',
                      help: 'form-profile-disable-calorie-goal-help'
                    }),
                }
            };

            //If in client mode, don't display the group dropdown
            if (!this.isClientDisplayMode()) {
                //If a supervisor is editing his own settings, he cannot set his group membership
                if (!this.isSupervisorSettingsSelfEdition()) {
                  this.listenTo(this.collection, {
                      'update': this.onGroupCollectionUpdate,
                      'click': this.onGroupClick
                  });
              }
            }
            this.listenTo(groupTreeView, 'click', this.onSelectGroup);
        },

        render: function() {
            // append the form
            this.assign(this.view.info, this.$el);

            this.generateZones();
            var view = this.view,
                zone = this.zone;

            this.assign(view.form.phone, zone.form.$phone)
                .assign(view.form.calorie_goal, zone.form.$calorie_goal)
                .assign(view.form.disable_calorie_goal, zone.form.$disable_calorie_goal);

            this.toggleCalorieGoalDisable();

            //If in client mode, don't display the group dropdown
            if (!this.isClientDisplayMode()) {
                //If a supervisor is editing his own settings, he cannot set his group membership or the expiration date.
                if (!this.isSupervisorSettingsSelfEdition()) {
                    this.assign(view.form.groups, zone.form.$groups);
                    this.assign(view.form.expiration, zone.form.$expiration);
                }
            }

            this.listenTo(this.model, 'change:disable_calorie_goal', this.toggleCalorieGoalDisable);
            return this;
        },

        //Used to know if the current user is a supervisor editing himself
        isSupervisorSettingsSelfEdition: function() {
          return this.model.get("_isSupervisor");
        },

        toggleCalorieGoalDisable: function() {
            this.view.form.calorie_goal.setDisable(this.model.get('disable_calorie_goal'));
        },

        //Used when this form is displayed from the nutrition calorie goal link by a supervisor
        isClientDisplayMode: function() {
            return Backbone.history.getFragment().indexOf('supervisor') === -1;
        },

        setDefaultCalorieGoal: function() {
         var userGender = this.model.get('gender');
         var calorie_goal = this.model.get('calorie_goal');

         if (_.isEmpty(calorie_goal)) {
             this.model.set('calorie_goal', this.model.getDefaultCalorieGoal());
         }
       },

        ////////////
        // events //
        ////////////
        onDisplayGroupManager: function() {
            UserEvents.groupManage();
        },

        onGroupCollectionUpdate: function() {
            if (!this.selectedGroup) {
                this.onSelectGroup(this.collection.at(0));
            }
            else {
              this.onSelectGroup(this.selectedGroup);
            }
        },

        onSelectGroup: function(groupModel) {
            var selectedGroup = this.selectedGroup;
            if (groupModel !== undefined && selectedGroup !== groupModel) {
                if (selectedGroup) {
                    selectedGroup.set('_menuActive', false);
                }

                this.selectedGroup = selectedGroup = groupModel;
            }

            this.view.form.groups.setLabel(selectedGroup.get('name'));
            this.model.moveToGroup(groupModel);
            this.view.form.groups.close();
            selectedGroup.set('_menuActive', true);
        }
    });

    return VAccountSettingsEditForm;
});

